import React, { useCallback, useContext, useState } from "react";
import {
  Box,
  Heading,
  HStack,
  Pressable,
  Spinner,
  Stack,
  Text,
  VStack,
} from "native-base";
import { Helmet } from "react-helmet-async";
import { FiEdit, FiEdit2, FiLock } from "react-icons/fi";
import styles from "./styles.module.css";
import colors from "../../../constants/colors";
import { StateContext, StatusContext } from "../../../contexts";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import routes from "../../../routes";
import FilePicker from "../../../components/filePicker";
import API from "../../../api";
import { allowExit, preventExit } from "../../../utils";
import Image from "../../../components/image";

function AgencyProfilePage() {
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const navigate = useNavigate();
  const [isUploading, setIsUploading] = useState(false);

  const onUploadPhoto = useCallback(
    async (files) => {
      setIsUploading(true);
      preventExit();
      try {
        const file = files.item(0);
        const formData = new FormData();
        formData.append("files", file);
        // TODO: Create a single request for update the photo
        const {
          data: [{ id: photo }],
        } = await API(state.jwt).post("/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        await API(state.jwt).put(`/users/${state.user.id}`, { photo });
        await state.refreshUser();
      } catch (error) {
        status.updateErrorMessage(error);
      }
      allowExit();
      setIsUploading(false);
    },
    [state, status],
  );

  const onSignOut = useCallback(() => {
    navigate(routes.home);
    state.updateIsLoggedIn(false);
  }, [navigate, state]);

  return (
    <VStack paddingX={60}>
      <Helmet>
        <title>Mi perfil</title>
      </Helmet>
      <HStack paddingY={8}>
        <Heading color={colors.secondary} fontSize="2xl">
          Mi perfil
        </Heading>
      </HStack>
      <HStack space={2} marginBottom={5}>
        <Heading color={colors.secondary} fontSize="lg">
          Mi perfil
        </Heading>
      </HStack>
      <HStack alignItems="flex-start" space={5}>
        <VStack alignItems="center" space={10}>
          <Box position="relative">
            <Stack
              backgroundColor="gray.200"
              width={200}
              height={200}
              borderRadius="full"
              overflow="hidden"
              justifyContent="center"
              alignItems="center"
              position="relative"
              opacity={isUploading ? 0.25 : 1}>
              {state.user?.photo?.url && (
                <Image
                  image={state.user.photo}
                  alt="profile"
                  objectFit="cover"
                />
              )}
              {isUploading && (
                <Spinner
                  size="lg"
                  color={colors.secondary}
                  position="absolute"
                />
              )}
            </Stack>
            <FilePicker
              onSelect={onUploadPhoto}
              accept="image/*"
              disabled={isUploading}>
              <Box
                shadow={2}
                backgroundColor="white"
                position="absolute"
                bottom={2}
                left={140}
                padding={3}
                borderRadius="full">
                <FiEdit2 color={colors.secondary} size={20} />
              </Box>
            </FilePicker>
          </Box>
          <VStack alignItems="center" space={1}>
            <Heading fontSize="3xl">{state.user.agency.name}</Heading>
            <Heading fontSize="lg">Empresa</Heading>
          </VStack>
        </VStack>
        <VStack flex={1} space={10}>
          <VStack flex={1} backgroundColor="white" padding={10} space={8}>
            <Heading color={colors.secondary} fontSize="xl">
              Información de contacto
            </Heading>
            <VStack space={5}>
              <label className={styles.input}>
                <Text>Nombres</Text>
                <input
                  type="text"
                  required
                  value={state.user.firstName}
                  readOnly
                />
              </label>
              <label className={styles.input}>
                <Text>Apellidos</Text>
                <input
                  type="text"
                  required
                  value={state.user.lastName}
                  readOnly
                />
              </label>
              <label className={styles.input}>
                <Text>Correo electrónico</Text>
                <input type="text" required value={state.user.email} readOnly />
              </label>
              <label className={styles.input}>
                <Text>Teléfono</Text>
                <input type="text" required value={state.user.phone} readOnly />
              </label>
            </VStack>
            <HStack alignItems="flex-end" justifyContent="space-between">
              <VStack>
                <Text>Fecha de registro</Text>
                <Text bold fontSize="lg">
                  {moment(state.user.createdAt).format("DD/MM/Y")}
                </Text>
                <br />
                <Text>Rol</Text>
                <Text bold fontSize="lg">
                  Administrador
                </Text>
              </VStack>
              <HStack space={5}>
                <Pressable>
                  <HStack
                    paddingY={2}
                    paddingX={5}
                    borderColor={colors.primary}
                    borderWidth={1}
                    borderRadius={5}
                    space={5}>
                    <FiLock color={colors.primary} size={20} />
                    <Text color={colors.primary}>Cambiar contraseña</Text>
                  </HStack>
                </Pressable>
                <Pressable>
                  <HStack
                    paddingY={2}
                    paddingX={5}
                    borderColor={colors.primary}
                    borderWidth={1}
                    borderRadius={5}
                    space={5}>
                    <FiEdit color={colors.primary} size={20} />
                    <Text color={colors.primary}>Editar</Text>
                  </HStack>
                </Pressable>
              </HStack>
            </HStack>
          </VStack>
          <VStack flex={1} backgroundColor="white" padding={10} space={8}>
            <Heading color={colors.secondary} fontSize="xl">
              Información de la empresa
            </Heading>
            <VStack space={5}>
              <label className={styles.input}>
                <Text>Nombre de la empresa</Text>
                <input
                  type="text"
                  required
                  value={state.user.agency.name}
                  readOnly
                />
              </label>
              <label className={styles.input}>
                <Text>Direccíon</Text>
                <input
                  type="text"
                  required
                  value={state.user.agency.address}
                  readOnly
                />
              </label>
              <Heading color={colors.secondary} fontSize="lg">
                Información de contacto
              </Heading>
              <label className={styles.input}>
                <Text>Nombre</Text>
                <input
                  type="text"
                  required
                  value={state.user.agency.managerFirstName}
                  readOnly
                />
              </label>
              <label className={styles.input}>
                <Text>Apellido</Text>
                <input
                  type="text"
                  required
                  value={state.user.agency.managerFirstName}
                  readOnly
                />
              </label>
              <label className={styles.input}>
                <Text>Teléfono</Text>
                <input
                  type="text"
                  required
                  value={state.user.agency.phone}
                  readOnly
                />
              </label>
            </VStack>
            <HStack alignItems="flex-end" justifyContent="space-between">
              <VStack>
                <Text>Fecha de registro</Text>
                <Text bold fontSize="lg">
                  {moment(state.user.agency.createdAt).format("DD/MM/Y")}
                </Text>
              </VStack>
              <Pressable>
                <HStack
                  paddingY={2}
                  paddingX={5}
                  borderColor={colors.primary}
                  borderWidth={1}
                  borderRadius={5}
                  space={5}>
                  <FiEdit color={colors.primary} size={20} />
                  <Text color={colors.primary}>Editar</Text>
                </HStack>
              </Pressable>
            </HStack>
          </VStack>
        </VStack>
      </HStack>
      <HStack justifyContent="space-between" marginTop={10}>
        <Pressable onPress={onSignOut}>
          <Text>Cerrar sesión</Text>
        </Pressable>
        <HStack space={3} justifyContent="flex-end">
          <Pressable
            backgroundColor={colors.primary}
            paddingY={3}
            paddingX={10}
            borderRadius={5}
            disabled>
            <Text color={colors.white}>Descuento / Comisión</Text>
          </Pressable>
          <Pressable
            backgroundColor={colors.primary}
            paddingY={3}
            paddingX={10}
            borderRadius={5}
            disabled>
            <Text color={colors.white}>Mi crédito</Text>
          </Pressable>
          <Link to={routes.agencyProfileDocuments}>
            <Box
              backgroundColor={colors.primary}
              paddingY={3}
              paddingX={10}
              borderRadius={5}>
              <Text color={colors.white}>Documentos</Text>
            </Box>
          </Link>
          <Link to={routes.agencyProfileBalance}>
            <Box
              backgroundColor={colors.primary}
              paddingY={3}
              paddingX={10}
              borderRadius={5}>
              <Text color={colors.white}>Saldo</Text>
            </Box>
          </Link>
        </HStack>
      </HStack>
    </VStack>
  );
}

export default AgencyProfilePage;
